module.exports = __webpack_public_path__ + "static/img/lb4.8369dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/lb4.png
// module id = T2VU
// module chunks = 0